var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaterialIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136_9345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14999 6H20.15",
    stroke: "#F4A460",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14999 12H20.15",
    stroke: "#F4A460",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14999 18H20.15",
    stroke: "#F4A460",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 7.11995C4.22232 7.12392 4.44079 7.06162 4.62759 6.94099C4.81438 6.82037 4.96104 6.64687 5.04889 6.44259C5.13673 6.23832 5.16179 6.01253 5.12086 5.79397C5.07993 5.57541 4.97486 5.37398 4.81906 5.21533C4.66325 5.05669 4.46374 4.94802 4.24596 4.90316C4.02817 4.8583 3.80196 4.87928 3.59614 4.96343C3.39032 5.04758 3.2142 5.19109 3.09023 5.37568C2.96625 5.56027 2.90003 5.77759 2.89999 5.99995C2.89995 6.29356 3.0152 6.57545 3.22093 6.78492C3.42667 6.9944 3.70643 7.11471 3.99999 7.11995Z",
    fill: "#F4A460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 13.12C4.28008 13.0936 4.54021 12.9636 4.72955 12.7556C4.9189 12.5475 5.02382 12.2763 5.02382 11.995C5.02382 11.7137 4.9189 11.4425 4.72955 11.2344C4.54021 11.0264 4.28008 10.8964 4.00001 10.87C3.84336 10.8552 3.68535 10.8733 3.53609 10.9231C3.38684 10.9729 3.24963 11.0534 3.13326 11.1593C3.01689 11.2652 2.92392 11.3942 2.8603 11.5381C2.79669 11.682 2.76382 11.8376 2.76382 11.995C2.76382 12.1523 2.79669 12.3079 2.8603 12.4519C2.92392 12.5958 3.01689 12.7248 3.13326 12.8307C3.24963 12.9366 3.38684 13.0171 3.53609 13.0669C3.68535 13.1167 3.84336 13.1348 4.00001 13.12Z",
    fill: "#F4A460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 19.1199C4.22232 19.1239 4.44079 19.0616 4.62759 18.941C4.81438 18.8204 4.96104 18.6469 5.04889 18.4426C5.13673 18.2383 5.16179 18.0125 5.12086 17.794C5.07993 17.5754 4.97486 17.374 4.81906 17.2153C4.66325 17.0567 4.46374 16.948 4.24596 16.9032C4.02817 16.8583 3.80196 16.8793 3.59614 16.9634C3.39032 17.0476 3.2142 17.1911 3.09023 17.3757C2.96625 17.5603 2.90003 17.7776 2.89999 17.9999C2.89995 18.2936 3.0152 18.5754 3.22093 18.7849C3.42667 18.9944 3.70643 19.1147 3.99999 19.1199Z",
    fill: "#F4A460"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136_9345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialIcon);
export default __webpack_public_path__ + "static/media/material-icon.52766acb28d78a50d86fde09a296f54c.svg";
export { ForwardRef as ReactComponent };